<div class="presence" *ngIf="invoice$ | async">
  <h4 class="presence-title">Active here</h4>
  <ng-container *ngIf="(viewers$ | async) as viewers">
    <p *ngIf="viewers.length === 0" class="empty">No other viewers right now.</p>
    <ul class="roster" *ngIf="viewers.length > 0">
      <li *ngFor="let v of viewers" [class.editing]="v.activity_type === 'editing'">
        <span class="name">{{ v.user_name }}</span>
        <span class="activity" *ngIf="v.activity_type === 'editing'">(editing)</span>
        <span class="activity" *ngIf="v.activity_type === 'viewing'">(viewing)</span>
      </li>
    </ul>
  </ng-container>

  <ng-container *ngIf="(activity$ | async) as badges">
    <div class="activity-badge" *ngFor="let badge of badges">
      {{ badge.initiatorName }} is {{ badge.workflowLabel | lowercase }}…
    </div>
  </ng-container>
</div>
